import "../CSS/Portfolio.css";

import img1 from "../images/Screenshot1.png";
import img2 from "../images/Screenshot2.png";
import img3 from "../images/Screenshot3.png";
import img4 from "../images/Screenshot4.png";
import img5 from "../images/Screenshot5.png";
import img6 from "../images/Screenshot6.png";
import img7 from "../images/Screenshot7.png";
import img8 from "../images/Screenshot8.png";
import img9 from "../images/ems.png";
import img10 from "../images/lms.png";


import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const services = [
  {
    image: img4,
    title: "IGF Chatbot",
    desc: "Developed an AI-powered chatbot for IGF(USA) using Python that leverages Retrieval-Augmented Generation (RAG) and vector embeddings to provide accurate, context-aware responses. The system retrieves relevant information from a knowledge base and combines it with large language model capabilities to generate intelligent answers",
  },
  {
    image: img1,
    title: "Ad-Portal",
    desc: "Developed a web-based advertisement portal that allows businesses to publish and manage advertisements through a centralized platform. The system provides an intuitive interface for posting ads, browsing listings, and managing advertisement content efficiently",
  },
  {
    image: img2,
    title: "Tasty Junction",
    desc: "Tasty Junction is a real-time restaurant ordering and kitchen assembly system that enables instant communication between waiters and chefs. The platform uses Socket.IO for real-time updates, allowing orders to be transmitted immediately from the waiter interface to the kitchen dashboard",
  },
  {
    image: img9,
    title: "Employee Management System",
    desc: "The Employee Management System (EMS) is a web-based application designed to help organizations efficiently manage employee records, attendance, and administrative operations. The platform provides a centralized interface where administrators can manage employee details, track attendance, and maintain organizational data",
  },
  {
    image: img8,
    title: "M.Ark Design Studio",
    desc: "Developed a modern architectural portfolio website for M.Ark Design Studio to showcase design projects, services, and the studio’s creative vision. The platform focuses on clean visual presentation, responsive design, and an engaging layout to highlight architectural work effectively",
  },
  {
    image: img7,
    title: "M-Desi Engineering Services",
    desc: "Developed a corporate website for M-Desi Construction Company to showcase their construction services, completed projects, and company profile. The platform provides a professional digital presence with a clean interface and responsive design",
  },
  {
    image: img5,
    title: "Appointment Booking System",
    desc: "The Slot & Appointment Booking System is a web-based platform designed to simplify appointment scheduling for businesses and service providers. The system allows users to view available time slots and book appointments through an intuitive interface",
  },
  {
    image: img10,
    title: "Library Management System",
    desc: "The LMS (Seat Booking and Management System) is a web-based platform designed to manage seat reservations and subscription-based access for shared spaces such as libraries, study centers, or coworking environments. The system allows administrators to manage seat availability, user registrations, and subscription plans, while users can easily book seats and manage their subscriptions through a streamlined interface. The platform helps automate seat allocation and subscription tracking, reducing manual management efforts",
  },
  {
    image: img6,
    title: "DataCloudX Technologies",
    desc: "Developed a corporate website for DataCloudX Technologies to showcase company services, digital solutions, and business offerings. The platform provides a professional digital presence with a clean interface and responsive design",
  },
  {
    image: img3,
    title: "Shree Jee Gavya",
    desc: "Shree Jee Gavya is a herbal product e-commerce platform built to provide a seamless online shopping experience for natural and Ayurvedic wellness products. The platform features responsive UI components, optimized product listing pages, and secure order workflows to ensure smooth navigation and efficient product discovery",
  },
];

function Portfolio() {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev === services.length - 1 ? 0 : prev + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  function toServicePage() {
    navigate("/services");
  }

  return (
    <div className="gx-portfolio-section">
      <div className="container-fluid gx-portfolio-container">
        {/* Top Center Heading */}
        <div className="gx-portfolio-heading">
          <h1 className="gx-title">Our Portfolio</h1>
        </div>

        <div className="row align-items-center gx-portfolio-row ">
          {/* Left Text Section */}
          <div className="col-lg-6 gx-service-text">
            <h3 className="gx-service-title">{services[activeIndex].title}</h3>

            <p className="gx-service-desc">{services[activeIndex].desc}</p>

            <button className="gx-btn" onClick={toServicePage}>
              View Services
            </button>
          </div>

          {/* Right Card Stack */}
          <div className="col-lg-6 gx-card-area">
            <div className="gx-card-stack">
              {services.map((serv, index) => {
                const position =
                  (index - activeIndex + services.length) % services.length;

                return (
                  <div
                    key={index}
                    className="gx-card"
                    style={{
                      transform: `
                        translate(-50%, -50%)
                        translate(${position * 55}px, ${-position * 32}px)
                        
                        scale(${1 - position * 0.05})
                      `,
                      zIndex: services.length - position,
                      opacity: position > 3 ? 0 : 1,
                    }}
                  >
                    <img
                      src={serv.image}
                      alt={serv.title}
                      className="gx-card-img"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;